export function initDropdowns(container = document) {
  container.querySelectorAll('[data-dropdown]').forEach(dropdown => {
    const trigger = dropdown.querySelector('.dropdown__trigger');
    const menu = dropdown.querySelector('.dropdown__menu');
    const items = dropdown.querySelectorAll('.dropdown__item');

    // Toggle au clic
    trigger.addEventListener('click', (e) => {
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      closeAllDropdowns(container); // Fermer les autres dans le container
      trigger.setAttribute('aria-expanded', !expanded);
      menu.setAttribute('aria-hidden', expanded);
      if (!expanded) {
        items[0]?.focus();
      }
    });

    // Navigation clavier
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        trigger.setAttribute('aria-expanded', 'true');
        menu.setAttribute('aria-hidden', 'false');
        items[0]?.focus();
      }
    });

    menu.addEventListener('keydown', (e) => {
      const focusable = Array.from(items);
      const index = focusable.indexOf(document.activeElement);
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          const next = (index + 1) % focusable.length;
          focusable[next].focus();
          break;
        case 'ArrowUp':
          e.preventDefault();
          const prev = (index - 1 + focusable.length) % focusable.length;
          focusable[prev].focus();
          break;
        case 'Escape':
          closeDropdown(dropdown);
          trigger.focus();
          break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          document.activeElement.click();
          closeDropdown(dropdown);
          break;
      }
    });

    // Click sur item
    items.forEach(item => {
      item.addEventListener('click', () => {
        const label = item.textContent.trim();
        trigger.querySelector('.dropdown__label').textContent = label;
        closeDropdown(dropdown);
      });
    });

    // Fermer si click en dehors
    document.addEventListener('click', (e) => {
      if (!dropdown.contains(e.target)) {
        closeDropdown(dropdown);
      }
    });
  });

  function closeDropdown(dropdown) {
    const trigger = dropdown.querySelector('.dropdown__trigger');
    const menu = dropdown.querySelector('.dropdown__menu');
    trigger.setAttribute('aria-expanded', 'false');
    menu.setAttribute('aria-hidden', 'true');
  }

  function closeAllDropdowns(scope = document) {
    scope.querySelectorAll('[data-dropdown]').forEach(d => closeDropdown(d));
  }
}